import { render, staticRenderFns } from "./examineModel.vue?vue&type=template&id=028d9c46&scoped=true"
import script from "./examineModel.vue?vue&type=script&lang=js"
export * from "./examineModel.vue?vue&type=script&lang=js"
import style0 from "./examineModel.vue?vue&type=style&index=0&id=028d9c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d9c46",
  null
  
)

export default component.exports